/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_List_Filters_SubInputs */



/**
* | output |
* | --- |
* | "Filter the Event List by multiple criteria" |
*
* @param {Event_List_Filters_SubInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_list_filters_sub = /** @type {((inputs?: Event_List_Filters_SubInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_List_Filters_SubInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtrer la liste d’événements selon plusieurs critères")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisliste nach mehreren Kriterien filtern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtra l'elenco degli eventi in base a più criteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отфильтруйте список событий по нескольким критериям.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtrar la lista de eventos por múltiples criterios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按多个条件筛选事件列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("複数の基準でイベントリストをフィルタリングする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कई मानदंडों के आधार पर इवेंट सूची को फ़िल्टर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtrar a lista de eventos por múltiplos critérios")
	return /** @type {LocalizedString} */ ("Filter the Event List by multiple criteria")
});